let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8gfFI")).then(() => parcelRequire('fuSM8'));